import fallbackFeatureFlag from '/src/assets/featureFlag.json';
import { getCookieChatbot, setCookieByHoursChatbot } from '/src/utils/cookiesUtils.js';

export const getFeatureFlagsChatbot = (accessToken, predicate = (response) => {}) => {
  // verify if the feature flag is inside the cookie
  if (!accessToken || accessToken === 'null') {
    // if not, use the fallback feature flag
    predicate(fallbackFeatureFlag);
  }
  const responseCookie = getCookieChatbot('featureFlag');
  if (responseCookie) {
    predicate(JSON.parse(responseCookie));
    return;
  }

  // if not fetch it from the server and save for 3 hours
  fetch(`${import.meta.env.VITE_APP_API_URL}/api/v1/feature-flag`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`,
    },
  }).then(response => {
    if (response.status === 200) {
      response.json().then((response) => {
        setCookieByHoursChatbot('featureFlag', JSON.stringify(response), 3);
        predicate(response);
      }).catch(() => {
        predicate(fallbackFeatureFlag);
      })
    }
  }).catch(error => {
    predicate(fallbackFeatureFlag);
  })
}
